export default __webpack_public_path__ + "static/media/IndiraChowdhury.9913c6d6.jpg";